<div id="container" class="d-flex flex-row gap-8 w-100 overflow-auto  pb-3 align-items-center" (wheel)="onWheel($event)">

  <div class="border box-shadow br-8 p-2 flex-grow-1" *ngFor="let d of data">

    <p class="font-12 text-nowrap" *ngIf="d.name">{{d.name}}</p>

    <div class="d-flex flex-row gap-8 align-items-center">
<!--   icones / type   -->
      <span *ngIf="!d.icon_type || d.icon_type == 'material'" class="font-14" [ngClass]="d.icon_class ? d.icon_class : 'material-icons-outlined'">{{d.icon}}</span>
      <img src="{{d.icon}}" alt="" *ngIf="d.icon_type == 'img'">
      <span *ngIf="d.icon_type == 'other'" [innerHTML]="d.icon" class="other_icon font-12"></span>

<!--   info / type   -->
      <span class="font-14 text-nowrap" *ngIf="d.info_type == 'clef'"> {{ d.info | translate }}</span>
      <span class="font-14 text-nowrap" *ngIf="d.info_type == 'string'"> {{ d.info }}</span>
      <span class="font-14 text-nowrap" *ngIf="d.info_type == 'age'"> {{ d.age + ' ans' }}</span>
      <span class="font-14 text-nowrap" *ngIf="d.info_type == 'number'"> {{ d.info | number:'1.0-2' }}</span>
    </div>

  </div>

</div>
